<template>
  <select
    v-if="isActiveDebug && !loading && viewComponents.length"
    class="drop-down-container"
    v-model="value"
  >
    <option
      v-for="(component, index) in viewComponents"
      :key="index"
      :value="component"
      :disabled="component.disabled"
    >
      {{ component.name }}
    </option>
    <option value="" selected disabled hidden>Intro Page</option>
    <div>{{ loading }}</div>
  </select>
</template>

<script>
//import { mapGetters } from "vuex";

export default {
  name: 'ActivityDropDown',
  props: {
    viewComponents: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      select: this.option,
      value: '',
      isActiveDebug: false,
    };
  },
  mounted() {
    this.isActiveDebug = this.$environments.APP_DEBUG;
  },
  watch: {
    value(selection) {
      this.$emit('on-select-component', { ...selection });
      this.onSwapComponent(selection.component);
    },
  },
  computed: {
    // ...mapGetters({
    //   loading: 'ActivityManagerModule/getLoading'
    // }),
  },
};
</script>

<style lang="stylus" scoped>
.drop-down-container
  position relative
  top -26px
  z-index 9999
  border-radius 6px
</style>
